import { api } from "./api_core";

export const qimenApi = {
  // 保存奇门排盘
  saveQimenChart: async (data) => {
    try {
      const response = await api.post("/qimen/save", data);
      return { success: true, id: response.data.id, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || "保存失败",
      };
    }
  },
  // 发布奇门卦例
  publishQimenChart: async (data) => {
    try {
      const response = await api.post("/qimen/publish", data);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || "发布失败",
      };
    }
  },
};